export default class StepperStickyNav {
  constructor() {
    document.querySelectorAll('.js-stepper-sticky-nav').forEach($el => new StepsElement($el));
  }
}

class StepsElement {
  MIN_DESKTOP_WIDTH = 1024;

  constructor($el) {
    this.$el = $el;
    this.$progressBar = this.$el.querySelector('.js-steps-progress-bar');
    this.$container = this.$el.querySelector('.js-steps-progress-container');
    this.$steps = [...this.$el.querySelectorAll('.js-steps-bar-step')];

    this.buildLeftPoints();
    window.addEventListener('scroll', this.scroll.bind(this));
    window.addEventListener('resize', this.resize.bind(this));
  }

  buildLeftPoints() {
    const { width } = this.$container.getBoundingClientRect();
    const { offsetWidth } = document.body;

    this.leftPoints = this.$steps.map($step => {
      // Calc percentage of the step position in the viewport
      const { left } = $step.getBoundingClientRect();

      let percentage = (left / offsetWidth) * 100;

      if (window.innerWidth < this.MIN_DESKTOP_WIDTH) {
        percentage = (left / (width + offsetWidth)) * 100;
      }

      // Calc where on the page the target is.
      const el = document.getElementById($step.href.split('#')[1])
      const y = el.offsetTop;

      return {
        $step,
        el,
        y,
        percentage
      };
    })
  }

  scroll() {
    const viewportTop = document.body.scrollTop
      + document.documentElement.scrollTop
      + window.innerHeight;

    // Passed state.
    for (const point of this.leftPoints) {
      point.$step.toggleAttribute('data-passed', viewportTop >= point.y);
    };

    // Active state.
    for (const [i, point] of this.leftPoints.entries()) {
      const nextY = this.leftPoints[i + 1]?.y || Infinity;
      point.$step.ariaSelected = viewportTop >= point.y && viewportTop < nextY;
    };

    // Progress bar width.
    const lastIndex = this.leftPoints.findLastIndex(point => viewportTop >= point.y);
    const percentageBar = this.leftPoints[lastIndex + 1]?.percentage ?? 100;
    const percentageOffset = this.leftPoints[lastIndex].percentage;

    this.$progressBar.style.width = `${percentageBar}%`;

    if (window.innerWidth < this.MIN_DESKTOP_WIDTH) {
      this.$container.style.transform = `translateX(-${percentageOffset}%)`;
    }
  }

  resize() {
    this.$container.style.transform = `translateX(0)`;
    this.buildLeftPoints();
  }
}
